import GeolocationModal from './GeolocationModal';

export default function geolocation() {
  new GeolocationModal();
}

document.addEventListener('shopify:section:load', () => {
  geolocation();
});
